import api from 'Application/api/api';

const getActivities = signal =>
	api.get('/activity-templates/get-all', {
		signal,
	});

export default getActivities;
